import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DeliveryInternationalForm } from '@pt/models';

@Component({
  standalone: false,
  selector: 'pu-delivery-view-international',
  templateUrl: './international.component.html',
  styleUrls: ['./international.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternationalComponent {
  delivery = input<DeliveryInternationalForm>();
}
